export const MIN_INCREMENT = 1;

export const BIDS_PAGE_SIZE = 100;
